import React from 'react';

/*
 * One student result poster, rendered as an image tile.
 *
 * WHY AN IMAGE AND NOT THE DATA CARD: the owner chose the poster treatment over
 * the native ResultCard — the posters are loud, individually coloured, and show
 * the student's face at size, which the uniform card deliberately did not.
 * ResultCard.js is retained unused for a future restyle; do not delete it.
 *
 * Every poster is square (1080x1080) and generated from the same record this
 * component receives, so `studentName`, `board` and `batchYear` are the alt
 * text — the text baked into the poster pixels is invisible to search engines
 * and to screen readers, and this is the only thing standing in for it.
 *
 * CONSENT GATE — enforced here as well as in the page, exactly as ResultCard
 * does: these are minors' faces and scores, and no surface may render one
 * without consentOnFile === true.
 */

export const hasConsent = (entry) => entry?.consentOnFile === true;

const altFor = ({ studentName, board, batchYear, subjects = [], metric, institution, outcome }) => {
  const marks = subjects.filter((s) => s.score).map((s) => `${s.name} ${s.score}`).join(', ');
  const result = outcome || institution || metric || marks;
  return [studentName, [board, batchYear].filter(Boolean).join(' '), result]
    .filter(Boolean)
    .join(' — ');
};

const ResultPosterTile = ({ entry, eager = false }) => {
  if (!hasConsent(entry) || !entry.posterSrc) return null;
  return (
    <figure className="m-0 rounded-[14px] lg:rounded-2xl overflow-hidden border border-brand-line bg-white">
      <img
        src={entry.posterSrc}
        alt={altFor(entry)}
        width="1080"
        height="1080"
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        className="block w-full h-auto aspect-square object-cover"
      />
    </figure>
  );
};

export default ResultPosterTile;
